"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParametricLine = void 0;
const Vector3_1 = require("../ValueObjects/Vector3");
class ParametricLine {
    constructor(parameters) {
        this.x0 = parameters.x0;
        this.y0 = parameters.y0;
        this.z0 = parameters.z0;
        this.a = parameters.a;
        this.b = parameters.b;
        this.c = parameters.c;
    }
    // See https://planetcalc.com/8253/
    static FromTwoPoint(p1, p2) {
        const dir = Vector3_1.Vector3.Subtract(p2, p1).unit;
        return this.FromPointDirection(p1, dir);
    }
    static FromPointDirection(point, direction) {
        return new ParametricLine({
            x0: point.x,
            y0: point.y,
            z0: point.z,
            a: direction.x,
            b: direction.y,
            c: direction.z,
        });
    }
    static Forward() {
        const p = Vector3_1.Vector3.Zero();
        const d = new Vector3_1.Vector3(0, 0, 1);
        return this.FromPointDirection(p, d);
    }
    static Backward() {
        const p = Vector3_1.Vector3.Zero();
        const d = new Vector3_1.Vector3(0, 0, -1);
        return this.FromPointDirection(p, d);
    }
    static Up() {
        const p = Vector3_1.Vector3.Zero();
        const d = new Vector3_1.Vector3(0, 1, 0);
        return this.FromPointDirection(p, d);
    }
    static Down() {
        const p = Vector3_1.Vector3.Zero();
        const d = new Vector3_1.Vector3(0, -1, 0);
        return this.FromPointDirection(p, d);
    }
    static Left() {
        const p = Vector3_1.Vector3.Zero();
        const d = new Vector3_1.Vector3(-1, 0, 0);
        return this.FromPointDirection(p, d);
    }
    static Right() {
        const p = Vector3_1.Vector3.Zero();
        const d = new Vector3_1.Vector3(1, 0, 0);
        return this.FromPointDirection(p, d);
    }
    static GetPointAtDistance(line, distance) {
        const x = line.x0 + line.a * distance;
        const y = line.y0 + line.b * distance;
        const z = line.z0 + line.c * distance;
        return new Vector3_1.Vector3(x, y, z);
    }
}
exports.ParametricLine = ParametricLine;
